import axios from 'axios'

/**
 * The backend returns precise, human-readable messages on 4xx responses
 * (e.g. "Strategic Intent is required for Business Opportunities."). Surface
 * them instead of a generic toast — a constraint the user can't see is a
 * dead end (audit F-39/INT-07).
 */
export function getApiErrorMessage(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) return undefined
  const responseData = error.response?.data as
    | { message?: string; errors?: Array<{ field?: string; message?: string }> }
    | undefined
  // A refused form names what is wrong in `errors`; the `message` beside it only says "Validation failed
  // for request", which left a person guessing what to change (F-90).
  const fieldMessages = (responseData?.errors ?? [])
    .map((fieldError) => fieldError.message)
    .filter((message): message is string => !!message)
  if (fieldMessages.length > 0) return [...new Set(fieldMessages)].join(' ')
  return responseData?.message
}

type MutationErrorNotifier = (message: string | undefined) => void

let notifier: MutationErrorNotifier | null = null

/** Registered by ToastProvider; consumed by the global MutationCache fallback. */
export function registerMutationErrorNotifier(fn: MutationErrorNotifier | null) {
  notifier = fn
}

export function notifyMutationError(message: string | undefined) {
  notifier?.(message)
}
